import React, { forwardRef } from 'react';

function SvgChevronDown(props, svgRef) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 16 16"
            width="1em"
            height="1em"
            ref={svgRef}
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.246 11.0855C7.20733 11.0478 7.042 10.9056 6.906 10.7731C6.05067 9.99638 4.65067 7.97008 4.22333 6.90951C4.15467 6.74845 4.00933 6.34124 4 6.12367C4 5.9152 4.048 5.71646 4.14533 5.52682C4.28133 5.29042 4.49533 5.10078 4.748 4.99687C4.92333 4.92997 5.448 4.82606 5.45733 4.82606C6.03133 4.72215 6.964 4.66499 7.99467 4.66499C8.97667 4.66499 9.87133 4.72215 10.454 4.80722C10.4633 4.81697 11.1153 4.92088 11.3387 5.03453C11.7467 5.24301 12 5.65022 12 6.086V6.12367C11.99 6.40748 11.7367 7.00433 11.7273 7.00433C11.2993 8.00774 9.968 9.98729 9.08333 10.7829C9.08333 10.7829 8.856 11.0069 8.714 11.1044C8.51 11.2563 8.25733 11.3317 8.00467 11.3317C7.72267 11.3317 7.46 11.2466 7.246 11.0855Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
